<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Add Block
    </button>

    <a-modal v-model="visible" title="Add new block">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
        <a-button key="submit" type="primary" htmlType="submit" :loading="loading" @click="handleSubmit">Submit</a-button>
      </template>

      <a-form class="mb-4" :form="form">

        <div class="row">
          <div class="col-12 col-md-6">
            <a-form-item label="Select Hostel">
              <a-select
                placeholder="Select Hostel"
                v-decorator="['hostel_id', { rules: [{ required: true, message: 'Please select a hostel!' } ] }]"
                @change="getHostels"
              >
                <a-select-option v-for="item in selectedHostel" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-12 col-md-6">
            <a-form-item label="Select Warden">
              <a-select
                show-search
                placeholder="Select Warden"
                v-decorator="['staff_id', { rules: [{ required: true, message: 'Please select a warden!' } ] }]"
                :filterOption="false"
                @search="onSearchWarden"
                @popupScroll="onScrollWarden"
                :loading="wardenLoading"
              >
                <a-select-option v-for="item in wardens" :key="item.id" :value="item.id">{{ item.first_name + ' ' + item.last_name }}</a-select-option>
                <template slot="notFoundContent">
                  <a-spin v-if="wardenLoading" size="small" />
                  <span v-else>No staff found</span>
                </template>
              </a-select>
            </a-form-item>
          </div>
        </div>

        <a-form-item label="Block Name">
          <a-input
            placeholder="Block Name"
            v-decorator="['name', {rules: [{ required: true, message: 'Please input a block name!' }]}]"
          />
        </a-form-item>

        <a-form-item label="Description">
          <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description']" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'blockAddModal',
  props: {
    formVisible: { type: Boolean, require: true },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      selectedHostel: [],
      wardens: [],
      wardenLoading: false,
      wardenSearch: '',
      wardenPagination: {
        current: 1,
        last: 1,
      },
    }
  },
  mounted: function () {
    this.getHostels()
    this.fetchWardens()
  },
  watch: {
    formVisible: function(n, o) {
      this.visible = n
    },
  },
  methods: {
    getHostels: function() {
      this.$http.get(`/api/hostel`)
        .then(({ data }) => {
          this.selectedHostel = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchWardens(search = '', page = 1) {
      this.wardenLoading = true
      this.wardenSearch = search
      this.$http.get('/api/teacher', {
        params: { limit: 10, page, search },
      })
        .then(({ data }) => {
          if (page === 1) {
            this.wardens = data.data
          } else {
            this.wardens = this.wardens.concat(data.data)
          }
          this.wardenPagination.current = data.meta.current_page
          this.wardenPagination.last = data.meta.last_page
        })
        .finally(() => {
          this.wardenLoading = false
        })
    },
    onSearchWarden(value) {
      this.fetchWardens(value, 1)
    },
    onScrollWarden(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target
      if (scrollTop + clientHeight >= scrollHeight - 10 && !this.wardenLoading && this.wardenPagination.current < this.wardenPagination.last) {
        this.fetchWardens(this.wardenSearch, this.wardenPagination.current + 1)
      }
    },
    showModal() {
      this.visible = true
      this.getHostels()
      this.fetchWardens()
    },
    handleCancel(e) {
      this.visible = false
    },
    handleSubmit(e) {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add the hostel!`,
            onOk: () => {
              this.$nprogress.start()
              this.$http
                .post('/api/hostel/block/add', {
                  hostel_id: values.hostel_id,
                  staff_id: values.staff_id,
                  name: values.name,
                  description: values.description,
                })
                .then((data) => {
                  this.visible = false
                  this.$emit('created')
                  this.form.resetFields()
                  this.$nprogress.done()
                  this.$notification['success']({
                    message: 'Block successfully added!',
                    description: `Block ${values.name} added successfully!`,
                  })
                })
                .catch(error => {
                  this.$nprogress.done()
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              console.log('Cancel')
            },
          })
        }
      })
    },
  },
}
</script>
